import React from 'react';
import PropTypes from 'prop-types';

const LoadingModal = props => {
  const height = document.getElementById(props.height)
    ? document.getElementById(props.height).offsetHeight + 35
    : '0';
  return (
    <div style={{ height: height }} className="loading-modal">
      <div className="box-loading-modal">
        <div className="loading-animate">
          <h2>
            <i className="fas fa-truck-moving" />
          </h2>
        </div>
        <h3>{props.language ? props.language.load.loading : 'Cargando'}</h3>
      </div>
    </div>
  );
};

export default LoadingModal;



// WEBPACK FOOTER //
// ./source/client/components/common/loadingModal.jsx